export default {
    methods: {
        isDeviceIos()
        {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        },
        isDeviceAndroid()
        {
            return /Android/.test(navigator.userAgent);
        }
    }
};
